import { MenuItem } from "@mui/material";
import { Form } from "formik";
import * as yup from "yup";
import FormikAutocomplete from "../../../commons/formik/formikAutocomplete";
import { FormikDateRangeInput, FormikDateRangeSearch } from "../../../commons/formik/formikDateRangeSearch";
import FormikForm from "../../../commons/formik/formikForm";
import FormikSelect from "../../../commons/formik/formikSelect";
import FormikTextField from "../../../commons/formik/formikTextField";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledNovedadesSearchForm } from "../../../styled/connectivity";

const validationSchema = yup.object().shape({
  art: yup.string().required("El ART es obligatorio"),
  status: yup.string().optional(),
  datePeriod: yup.string().optional(),
  startDate: yup
    .date()
    .required("La fecha desde es obligatoria")
    .typeError("Fecha inválida")
    .test(
      "startDate-before-endDate",
      "La fecha desde debe ser anterior a la fecha hasta",
      function (value) {
        const { endDate } = this.parent;
        if (value && endDate && new Date(value) > new Date(endDate)) {
          return false;
        }
        return true;
      },
    ),

  endDate: yup
    .date()
    .required("La fecha hasta es obligatoria")
    .typeError("Fecha inválida")
    .test(
      "endDate-after-startDate",
      "La fecha hasta debe ser posterior a la fecha desde",
      function (value) {
        const { startDate } = this.parent;
        if (value && startDate && new Date(value) < new Date(startDate)) {
          return false;
        }
        return true;
      },
    ),
});

const initialValues = {
  art: "",
  siniestro: "",
  dni: "",
  providerId: "",
  status: "",
  datePeriod: "all",
  startDate: null,
  endDate: null,
};

const NovedadesSearchForm = ({
  isSearching,
  arts,
  providers,
  handleSubmitSearch,
  model,
  onArtChange,
  handleClearSearch
}) => {

  const handleOnArtChange = (artValue, setFieldValue) => {
    if (artValue && onArtChange) {
      onArtChange(artValue);
    }
    setFieldValue("providerId", null);
  };

  const handleClear = (resetForm) => {
    handleClearSearch();
    resetForm({ values: initialValues });
  };

  return (
    <div>
      <StyledNovedadesSearchForm.StyledPaper>
        {!isSearching ? (
          <FormikForm
            initialValues={model ?? initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmitSearch}>
            {({ values, setFieldValue, resetForm }) => (
              <Form>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikSelect
                    name="art"
                    label="Art"
                    variant="standard"
                    callBack={(value) => handleOnArtChange(value, setFieldValue)}
                  >
                    {arts.map((art) => (
                      <MenuItem value={art.id} key={art.id}>
                        {art.nombre}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikTextField name="siniestro" label="Siniestro" variant="standard" />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikTextField name="dni" label="DNI" variant="standard" />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikAutocomplete
                    name="providerId"
                    label="Prestador"
                    variant="standard"
                    options={providers}
                  />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikSelect
                    name="status"
                    label="Estado"
                    variant="standard"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="true">Abierto</MenuItem>
                    <MenuItem value="false">Cerrado</MenuItem>
                  </FormikSelect>
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikDateRangeSearch />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikDateRangeInput
                    name="startDate"
                    label="Fecha Desde"
                  />
                </StyledNovedadesSearchForm.StyledInput>
                <StyledNovedadesSearchForm.StyledInput>
                  <FormikDateRangeInput
                    name="endDate"
                    label="Fecha Hasta"
                  />
                </StyledNovedadesSearchForm.StyledInput>

                <StyledNovedadesSearchForm.ButtonContainer>
                  <StyledNovedadesSearchForm.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    disabled={isSearching}>
                    Buscar
                  </StyledNovedadesSearchForm.StyledButton>
                  <StyledNovedadesSearchForm.StyledButton
                    variant="contained"
                    type="button"
                    color="primary"
                    disabled={isSearching}
                    style={{ marginLeft: 8 }}
                    onClick={() => handleClear(resetForm)}>
                    Limpiar
                  </StyledNovedadesSearchForm.StyledButton>
                </StyledNovedadesSearchForm.ButtonContainer>
              </Form>
            )}
          </FormikForm>
        ) : (
          <CircularLoading />
        )}
      </StyledNovedadesSearchForm.StyledPaper>
    </div>
  );
};

export default NovedadesSearchForm;
